import React from "react";
import fieldActivity from "../../Assets/Services/fieldActivity.png";
import design from "../../Assets/Services/design.png";
import projectSupport from "../../Assets/Services/projectSupport.png";
import Vector from "../../Assets/Services/Vector.png";

function RangeOfServies() {
  return (
    <div
      className="mt-10 space-y-5 px-6 md:px-16 py-2"
      style={{ fontFamily: "Nunito, sans-serif" }}
    >
      <header>
        <h1
          // style={{ fontFamily: "Nunito, sans-serif" }}
          className="text-3xl lg:text-5xl font-semibold mb-4 text-center"
          data-aos="fade-down"
        >
          Range of Services
        </h1>
      </header>

      <div className="text-center items-center md:text-md lg:text-xl text-gray-500 flex-wrap">
        <span className="text-center" data-aos="zoom-in-up">
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum,
          facere?
        </span>
      </div>

      <div className="grid grid-cols-1 mt-4 md:grid-cols-3">
        <div className="p-2 md:p-4" data-aos="fade-right">
          <div className="p-2 flex space-x-2 md:space-x-3 lg:space-x-8 items-center bg-[#E5FCFF] border-l-4 border-[#0218DC] rounded-lg">
            <img src={fieldActivity} alt="" className="w-8 md:w-14 " />
            <h1 className="p-2 text-md lg:text-lg font-semibold tracking-wider">
              FIELD ACTIVITIES
            </h1>
          </div>

          <div className="text-gray-600 text-base md:text-md lg:text-xl mb-2 font-semibold flex flex-col p-4 tracking-wide">
            <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span>Site Investigation</span>
            </div>

            <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span>Topographical Survey</span>
            </div>

            <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span>Hydrographic Survey</span>
            </div>

            <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span>Bathymetric survey</span>
            </div>

            <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span>Study of Rocks and strata Material survey & testing</span>
            </div>

            <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span>Quality testing & monitoring</span>
            </div>
            {/* 
            <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span>LiDAR survey</span>
            </div> */}

            <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span>Traffic Studies</span>
            </div>

            {/* <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span>
                Distress mapping & rehabilitation measures
              </span>
            </div> */}

            <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span>Pavement Investigations</span>
            </div>

            <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span>Non Destructive Testing</span>
            </div>

            {/* <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span>
                Marine Investigations
              </span>
            </div> */}
          </div>
        </div>

        <div className="p-2 md:p-4" data-aos="zoom-in-up">
          <div className="p-2 flex space-x-2 md:space-x-3 lg:space-x-8 items-center bg-[#E5FCFF] border-l-4 border-[#0218DC] rounded-lg">
            <img src={design} alt="" className=" w-8 md:w-14" />
            <h1 className="p-2 text-md lg:text-lg font-semibold tracking-wider">
              DESIGN SERVICES
            </h1>
          </div>

          <div className="text-gray-600 text-base md:text-md lg:text-xl mb-2 font-semibold flex flex-col p-4 tracking-wide">
            {/* <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span className="text-md font-semibold">
                Construction Supervision
              </span>
            </div> */}

            <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span className="text-md font-semibold">Building</span>
            </div>
            <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span className="text-md font-semibold">Bridge & ROB</span>
            </div>

            {/* <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span className="text-md font-semibold">
                Project facilitation
              </span>
            </div> */}

            <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span className="text-md font-semibold">Pavement Design</span>
            </div>

            {/* <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span className="text-md font-semibold w-56">
                Authority's Engineer/Independent Engineer
              </span>
            </div> */}

            {/* <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span className="text-md font-semibold w-52">
                3rd party quality audit
              </span>
            </div> */}
          </div>
        </div>

        <div className="p-2 md:p-4" data-aos="fade-left">
          <div className="flex space-x-2 py-2 md:space-x-3 md:p-2 lg:space-x-8 lg:items-center bg-[#E5FCFF] border-l-4 border-[#0218DC] rounded-lg">
            <img src={projectSupport} className=" w-8 md:w-14" />
            <h1 className="pt-2 md:pb-0 md:pt-0 text-md font-semibold lg:text-lg tracking-wider">
              OUR LAB SERVICES
            </h1>
          </div>

          <div className="text-gray-600 text-base md:text-md lg:text-xl mb-2 font-semibold flex flex-col p-4 tracking-wide">
            <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span>Soil</span>
            </div>

            <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span className="text-md font-semibold">Cement</span>
            </div>

            <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span className="text-md font-semibold w-56">
                Building Material
              </span>
            </div>

            {/* <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span className="text-md font-semibold">Proof Checking</span>
            </div> */}

            {/* <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span className="text-md font-semibold w-56">
                Structural Rehabilitation measures
              </span>
            </div> */}

            <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span className="text-md font-semibold w-52">Steel</span>
            </div>

            <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span className="text-md font-semibold w-52">Rock</span>
            </div>
            <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span className="text-md font-semibold w-60">
                Water both physical & chemical tests
              </span>
            </div>

            {/* <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span className="text-md font-semibold w-52">
                Tender document
              </span>
            </div> */}

            {/* <div className="flex p-2 items-center justify-start">
              <img src={Vector} className="h-4 pr-4" />
              <span className="text-md font-semibold w-52">
                Safety consultancy
              </span>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default RangeOfServies;
